/* global Swiper */
(() => {
  const initTutorialsCarousel = () => {
    document.querySelectorAll('.tutorials-carousel-swiper').forEach((swiperEl) => {
      const sectionId = swiperEl.id;
      const section = swiperEl.closest('.tutorials-carousel-section');
      if (!section) return;

      const isCentered = section.classList.contains('tutorials-carousel-container--centered');
      const prevButton = section.querySelector('.tutorials-carousel-arrow--left');
      const nextButton = section.querySelector('.tutorials-carousel-arrow--right');

      // Wait for images only — do not force video metadata downloads before init
      const waitForMedia = (callback) => {
        const images = section.querySelectorAll('.tutorials-carousel-card-media img');

        if (images.length === 0) {
          callback();
          return;
        }

        let loadedCount = 0;
        const totalMedia = images.length;

        const checkComplete = () => {
          loadedCount++;
          if (loadedCount === totalMedia || document.readyState === 'complete') {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                callback();
              });
            });
          }
        };

        images.forEach((img) => {
          if (img.complete) {
            checkComplete();
          } else {
            img.addEventListener('load', checkComplete, { once: true });
            img.addEventListener('error', checkComplete, { once: true });
          }
        });

        setTimeout(() => {
          if (loadedCount < totalMedia) {
            callback();
          }
        }, 500);
      };

      waitForMedia(() => {
        section.querySelectorAll('.tutorials-carousel-video').forEach((video) => {
          const armSources = () => {
            const sources = video.querySelectorAll('source[data-src]');
            if (!sources.length) return false;
            sources.forEach((source) => {
              source.setAttribute('src', source.getAttribute('data-src'));
              source.removeAttribute('data-src');
            });
            video.load();
            return true;
          };
          video.addEventListener('pointerdown', armSources);
          video.addEventListener('play', function onPlay() {
            if (!armSources()) return;
            video.removeEventListener('play', onPlay);
            video.play().catch(function () {});
          });
        });

        const swiper = new Swiper(`#${CSS.escape(sectionId)}`, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          grabCursor: true,
          freeMode: false,
          allowTouchMove: true,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          on: {
            init: function () {
              updateArrowStates(this);
              // Set initial transform for 5 items
              if (isCentered && this.slides.length === 5) {
                const wrapper = this.wrapperEl;
                // At 1920px+, center items (all visible)
                if (window.innerWidth >= 1920) {
                  this.setTranslate(0);
                } 
                // Below 1920px, show partial visibility
                else if (window.innerWidth >= 640) {
                  this.setTranslate(-77.5);
                }
              }
              // Use multiple requestAnimationFrame to ensure layout is complete
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  centerSlidesIfNeeded(this);
                });
              });
            },
            slideChange: function () {
              updateArrowStates(this);
              // Re-center after slide change if in centered mode (but not at 1920px+ where slider is disabled)
              if (isCentered && window.innerWidth >= 640 && window.innerWidth < 1920) {
                setTimeout(() => {
                  centerSlidesIfNeeded(this);
                }, 10);
              }
            },
            resize: function () {
              setTimeout(() => {
                centerSlidesIfNeeded(this);
                updateArrowStates(this);
                // Re-apply initial transform on resize
                if (isCentered && this.slides.length === 5) {
                  if (window.innerWidth >= 1920) {
                    this.setTranslate(0);
                  } else if (window.innerWidth >= 640) {
                    this.setTranslate(-77.5);
                  }
                }
              }, 100);
            },
          },
        });
      });

      function centerSlidesIfNeeded(swiperInstance) {
        // For tutorial carousel with 5 items
        if (isCentered && window.innerWidth >= 640) {
          requestAnimationFrame(() => {
            const slides = swiperInstance.slides;
            const wrapper = swiperInstance.wrapperEl;
            
            // At 1920px+, disable slider and center all items (all are visible)
            if (slides.length === 5 && window.innerWidth >= 1920) {
              swiperInstance.allowTouchMove = false;
              swiperInstance.allowSlideNext = false;
              swiperInstance.allowSlidePrev = false;
              // Reset transform to center items
              swiperInstance.setTranslate(0);
            } 
            // Below 1920px, allow scrolling for partial visibility
            else if (slides.length === 5) {
              swiperInstance.allowTouchMove = true;
              swiperInstance.allowSlideNext = true;
              swiperInstance.allowSlidePrev = true;
              // Set initial transform to show first/last items partially - let Swiper handle it
              swiperInstance.setTranslate(-77.5);
            } else {
              // For other cases, check if slides fit
              const wrapper = swiperInstance.wrapperEl;
              const container = swiperInstance.el;

              if (slides.length > 0) {
                // Calculate total width of all slides including margins
                let totalWidth = 0;
                slides.forEach((slide, index) => {
                  const slideRect = slide.getBoundingClientRect();
                  const slideStyle = window.getComputedStyle(slide);
                  const slideWidth = slideRect.width;
                  const slideMarginRight = (index < slides.length - 1) ? parseFloat(slideStyle.marginRight) || 0 : 0;
                  totalWidth += slideWidth + slideMarginRight;
                });

                // Get the relativeContainer to account for wrapper padding
                const relativeContainer = container.closest('.tutorials-carousel-relativeContainer');
                const containerWidth = relativeContainer ? relativeContainer.clientWidth : container.clientWidth;

                // Only disable swiper if all slides fit within the container
                if (totalWidth <= containerWidth && containerWidth > 0) {
                  // Reset any transforms - CSS will handle centering
                  swiperInstance.setTranslate(0);
                  wrapper.style.transform = 'translate3d(0px, 0px, 0px)';
                  // Disable swiper when centered
                  swiperInstance.allowTouchMove = false;
                  swiperInstance.allowSlideNext = false;
                  swiperInstance.allowSlidePrev = false;
                } else {
                  // Slides don't fit, allow normal scrolling
                  swiperInstance.allowTouchMove = true;
                  swiperInstance.allowSlideNext = true;
                  swiperInstance.allowSlidePrev = true;
                }
              }
            }
          });
        } else {
          // Below 640px or not centered, allow normal scrolling
          swiperInstance.allowTouchMove = true;
          swiperInstance.allowSlideNext = true;
          swiperInstance.allowSlidePrev = true;
        }
      }

      function updateArrowStates(swiperInstance) {
        // Check if slides fit and should be centered
        const shouldDisableArrows = () => {
          if (!isCentered || window.innerWidth < 640) return false;

          const slides = swiperInstance.slides;
          const container = swiperInstance.el;
          const containerWidth = container.clientWidth;

          let totalWidth = 0;
          slides.forEach((slide, index) => {
            const slideRect = slide.getBoundingClientRect();
            const slideStyle = window.getComputedStyle(slide);
            const slideWidth = slideRect.width;
            const slideMarginRight = (index < slides.length - 1) ? parseFloat(slideStyle.marginRight) || 0 : 0;
            totalWidth += slideWidth + slideMarginRight;
          });

          return totalWidth <= containerWidth;
        };

        if (prevButton) {
          prevButton.disabled = swiperInstance.isBeginning || shouldDisableArrows();
        }
        if (nextButton) {
          nextButton.disabled = swiperInstance.isEnd || shouldDisableArrows();
        }
      }
    });
  };

  const runInit = () => {
    if (typeof Swiper !== 'undefined') {
      initTutorialsCarousel();
    } else {
      document.addEventListener('swiper-loaded', initTutorialsCarousel, { once: true });
    }
  };

  // Try multiple initialization strategies
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  // Also run on window load as a fallback
  window.addEventListener('load', () => {
    setTimeout(() => {
      initTutorialsCarousel();
    }, 100);
  });
})();

